export const assembledCloudflareDomains = (list) => {
  const external = list.filter(item => item.domain_origin === 'external');
  const externalNonexistent = [...external].filter(item => item.status === 'nonexistent');
  const externalInactive = [...external].filter(item => item.status === 'inactive');
  const externalPending = [...external].filter(item => item.status === 'pending');
  const externalDelay = [...external].filter(item => item.status === 'delay');
  const externalInactiveDelay = [...external].filter(item => item.status === 'inactive_delay');
  const externalActive = [...external].filter(item => item.status === 'active');
  const externalActivationPointingError = [...external].filter(item => item.status === 'activation_pointing_error');
  const externalInactivationPointingError = [...external].filter(item => item.status === 'inactivation_pointing_error');
  const externalError = [...external].filter(item => item.status === 'error');

  const internal = list.filter(item => item.domain_origin === 'internal');
  const internalNonexistent = [...internal].filter(item => item.status === 'nonexistent');
  const internalInactive = [...internal].filter(item => item.status === 'inactive');
  const internalPending = [...internal].filter(item => item.status === 'pending');
  const internalDelay = [...internal].filter(item => item.status === 'delay');
  const internalInactiveDelay = [...internal].filter(item => item.status === 'inactive_delay');
  const internalActive = [...internal].filter(item => item.status === 'active');
  const internalError = [...internal].filter(item => item.status === 'activation_pointing_error');
  const internalInactivationPointingError = [...internal].filter(item => item.status === 'inactivation_pointing_error');
  const internalPointedToExternalProvider = [...internal].filter(item => item.status === 'external_provider');
  const internalActivationPointingError = [...internal].filter(item => item.status === 'error');

  const sortedList = [];
  sortedList.push(...externalNonexistent);
  sortedList.push(...internalPending);
  sortedList.push(...internalPointedToExternalProvider);
  sortedList.push(...internalActivationPointingError);
  sortedList.push(...externalPending);
  sortedList.push(...internalDelay);
  sortedList.push(...externalDelay);
  sortedList.push(...externalInactiveDelay);
  sortedList.push(...internalInactiveDelay);
  sortedList.push(...externalActivationPointingError);
  sortedList.push(...internalInactivationPointingError);
  sortedList.push(...externalInactivationPointingError);
  sortedList.push(...internalActive);
  sortedList.push(...externalActive);
  sortedList.push(...internalNonexistent);
  sortedList.push(...internalInactive);
  sortedList.push(...externalInactive);
  sortedList.push(...externalError);
  sortedList.push(...internalError);
  return sortedList;
};

export const assembledFeatures = (data) => {
  const features = Object.keys(data).reduce((acc, key) => {
    acc[key] = {
      status: data[key].status,
      blocked_until: data[key].blocked_until,
      loading: false,
    };
    return acc;
  }, {});

  return features;
};

export const assembledNewRule = (currentList = [], newList = []) => {
  const currentIds = currentList.map(item => item.rule_id);
  const newRule = newList.find(item => !currentIds.includes(item.rule_id));

  return newRule;
};

export const assembledRulesList = (rulesList) => {
  const newList = rulesList.map(item => ({
    ...item,
    loading: false,
    blocked_until: null,
  }));

  return newList;
};

export const editRuleOnList = ({
  currentRulesList, newRulesList, ruleId, blockedUntil,
}) => {
  const newItem = newRulesList.find(item => item.rule_id === ruleId);

  const newList = currentRulesList.map((item) => {
    if (item.rule_id === ruleId) {
      return {
        ...item,
        ...newItem,
        blocked_until: blockedUntil,
      };
    }
    return item;
  });

  return newList;
};

export const deleteRuleOnList = ({ currentRulesList, ruleId }) => {
  const newList = currentRulesList.filter(item => item.rule_id !== ruleId);

  return newList;
};
